
const Main = () => import('@/views/main');
const statementPage = () => import('@/views/statement');
const ticketCount = () => import('@/views/statement/ticket-count');
const ticketStatic = () => import('@/views/statement/ticket-static');
const ticketSettle = () => import('@/views/statement/ticket-settle');
const ticketSettleDetail = () => import('@/views/statement/ticket-settle-detail');
const ticketCountDetail = () => import('@/views/statement/ticket-count-detail');
const storedConsumStatistics = () => import('@/views/statement/stored-consum-statistics');
const storedRechargeReport = () => import('@/views/statement/stored-recharge-report');
const storedConsumRepord = () => import('@/views/statement/stored-consum-repord');
const plusGiveTicket = () => import('@/views/statement/plusGiveTicket');
const usingDetail = () => import('@/views/order/usingDetail');
const wristRepord = () => import('@/views/statement/wrist-repord');
const recommendStatistics = () => import('@/views/statement/staff-static');
const inShopStatistics = () => import('@/views/statement/in-count');
const ticketVerStatistics = () => import('@/views/statement/ticket-verify');
const ticketSellStatistics = () => import('@/views/statement/ticket-sale');
const attendanceRecordManage = () => import('@/views/statement/attendance');
const employeeManage = () => import('@/views/statement/employee-manage');

export default [{
    path: '/statement',
    name: 'statement',
	redirect: {
		name: 'recommendStatistics'
	},
    component: Main,
    meta: {
        name: '报表管理',
        hide: false,
        unfold: true,
		iconType: "6"
    },
    children: [
        {
            path: '/plusGiveTicket',
            name: 'plusGiveTicket',
            component: plusGiveTicket,
            meta: {
                name: '门店加赠票列表'
            },
            children: [
                {
                    path: "usingDetail",
                    component: usingDetail,
                    name: "plusGiveTicketUsingDetail",
                    hide: true,
                    unfold: false,
                    meta: {
                        name: '使用详情'
                    },
                },
            ]
        },
        // {
        //     path: '/statementPage',
        //     name: 'statementPage',
        //     component: statementPage,
        //     meta: {
        //         name: '手环使用报表'
        //     },
        // },
        {
            path: '/ticketCount',
            name: 'ticketCount',
            component: ticketCount,
            meta: {
                name: '票券核销统计'
            },
        },
        {
            path: '/ticketStatic',
            name: 'ticketStatic',
            component: ticketStatic,
            meta: {
                name: '票券核销结算'
            },
            children: [
                {
                    path: 'ticketCountDetail',
                    name: 'ticketCountDetail',
                    component: ticketCountDetail,
                    meta: {
                        name: '票券核销结算'
                    },
                },
            ]
        },
        {
            path: '/ticketSettle',
            name: 'ticketSettle',
            component: ticketSettle,
            meta: {
                name: '票券余额结算'
            },
            children: [{
                path: 'ticketSettleDetail',
                name: 'ticketSettleDetail',
                component: ticketSettleDetail,
                meta: {
                    name: '票券余额结算明细'
                },
            }]
        },
        // {
        //     path: '/storedConsumStatistics',
        //     name: 'storedConsumStatistics',
        //     component: storedConsumStatistics,
        //     meta: {
        //         name: '储值消费统计'
        //     },
        // },
        // {
        //     path: '/storedRechargeReport',
        //     name: 'storedRechargeReport',
        //     component: storedRechargeReport,
        //     meta: {
        //         name: '储值充值报表'
        //     },
        // },
        // {
        //     path: '/storedConsumRepord',
        //     name: 'storedConsumRepord',
        //     component: storedConsumRepord,
        //     meta: {
        //         name: '储值消费报表'
        //     },
        // },
        // {
        //     path: '/wristRepord',
        //     name: 'wristRepord',
        //     component: wristRepord,
        //     meta: {
        //         name: '智能腕卡报表'
        //     },
        // },
        {
            path: '/recommendStatistics',
            name: 'recommendStatistics',
            component: recommendStatistics,
            meta: {
                name: '员工业绩统计'
            }
        },
        {
            path: '/attendanceRecordManage',
            name: 'attendanceRecordManage',
            component: attendanceRecordManage,
            meta: {
                name: '员工打卡'
            }
        },
        {
            path: '/employeeManage',
            name: 'employeeManage',
            component: employeeManage,
            meta: {
                name: '考勤人员管理'
            }
        },
        {
            path: '/inShopStatistics',
            name: 'inShopStatistics',
            component: inShopStatistics,
            meta: {
                name: '入园人数汇总'
            }
        },
        {
            path: '/ticketVerStatistics',
            name: 'ticketVerStatistics',
            component: ticketVerStatistics,
            meta: {
                name: '票券核销汇总'
            }
        },
        {
            path: '/ticketSellStatistics',
            name: 'ticketSellStatistics',
            component: ticketSellStatistics,
            meta: {
                name: '销售门票统计'
            }
        },
    ]
}]

